export default __webpack_public_path__ + "static/media/miguel-lopes-15.ba7607ee.jpg";